<section class="container-fluid" style="text-align: center;">
    <div class="row">
        <div class="col-12">
            <textarea [(ngModel)]="mensaje" name="" id="" cols="30" rows="10"></textarea>
            <br>
            <button class="btn btn-success" (click)="agregarMensaje()">Agregar mensaje</button>
        </div>
    </div>
</section>